import './Navbar.css';

export default function Navbar({ sectionLabel }) {
  return (
    <nav className="navbar">
      {/* Left: brand mark */}
      <div className="navbar-brand">
        <img
          src="https://eightfold.ai/wp-content/uploads/logo_alt.svg"
          alt="Eightfold.ai"
          className="navbar-logo"
        />
        <span className="navbar-title">Interview 360</span>
      </div>

      {/* Right: section chip */}
      {sectionLabel && (
        <div className="navbar-right">
          <span className="navbar-section-label">{sectionLabel}</span>
        </div>
      )}
    </nav>
  );
}
